import { render, staticRenderFns } from "./ProductReward.vue?vue&type=template&id=65e923b6&scoped=true&"
import script from "./ProductReward.vue?vue&type=script&lang=js&"
export * from "./ProductReward.vue?vue&type=script&lang=js&"
import style0 from "./ProductReward.vue?vue&type=style&index=0&id=65e923b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e923b6",
  null
  
)

export default component.exports